// ArChat Language Extension
// Created: 13-03-2026 00:00:00
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';

export const plansTranslationsPl = {
  ...plansTranslationsEn,
  'plans.modal.title': 'Ulepsz plan',
  'plans.modal.comparison_title': 'Porównanie planów',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': 'Plan darmowy',
  'plans.free.features.contacts': 'Maksymalnie 2 kontakty na użytkownika',
  'plans.free.features.conversations': 'Maksymalnie 2 aktywne rozmowy na konto',
  'plans.free.features.no_export': '30 000 znaków/mies. na konto; 34 wiad./dzień i 1 000/mies.; brak eksportu',
  'plans.free.features.no_advanced': 'Brak plików i magazynu; historia 30 dni; 1 urządzenie na użytkownika',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Plan Founder',
  'plans.foundation.features.contacts': 'Ten sam kontrakt premium co PRO (do 100 kontaktów na użytkownika)',
  'plans.foundation.features.conversations': 'Nielimitowane czaty (tenant); te same limity co PRO',
  'plans.foundation.features.badge': 'Program Founder (150 numerowanych miejsc)',
  'plans.foundation.features.support': 'USD 15/mies., dopóki są miejsca Founder',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Plan Pro',
  'plans.pro.features.contacts': 'Do 100 kontaktów na użytkownika',
  'plans.pro.features.conversations': 'Nielimitowane czaty (tenant); 1 667 wiad./dzień, 50 tys./mies.',
  'plans.pro.features.export': 'Do 50 MB (tenant); eksport, tłumaczenie i pliki wg planu',
  'plans.pro.features.notifications': 'Do 3 urządzeń na użytkownika; nielimitowane zaproszenia (tenant)',
  'plans.actions.free': 'Aktualny plan',
  'plans.actions.foundation': 'Zostań Founderem',
  'plans.actions.pro': 'Przejdź na PRO',
  'plans.badges.recommended': 'POLECANY',
  'plans.badges.limited': 'LIMITOWANE',
  'plans.badges.foundation': 'Founder',
  'plans.compare.title': 'Wybierz swój plan',
  'plans.compare.cta.foundation': 'Zostań Founderem',
  'plans.compare.cta.pro': 'Przejdź na PRO',
  'plans.compare.active': 'Aktualny plan',
  'plans.limit.reached': 'Limit osiągnięty — Zmień plan',
  'plans.compare.pro.adjustment_notice': 'Cena może zostać dostosowana do warunków usługi.',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.limited': '',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.founder.remaining': '{count} Founder seats remaining',
  'plans.founder.remaining_last': 'Last {count} Founder seats',
  'plans.founder.remaining_limited': 'Limited: {count} seats left',
  'plans.founder.remaining_very_low': 'Only {count} Founder seats left',
  'plans.founder.soldout': 'Founder sold out',
  'plans.compare.institucional.title': 'Instytucjonalny',
  'plans.compare.yourPlan': 'Twój plan',
  'plans.modal.free.line1': '30 000 znaków miesięcznie na konto.',
  'plans.modal.free.line2': 'Do 2 kontaktów na użytkownika.',
  'plans.modal.free.line3': 'Do 2 aktywnych rozmów na konto.',
  'plans.modal.free.line4': 'Brak załączników i miejsca na dane.',
  'plans.modal.free.line5': 'Brak eksportu danych.',
  'plans.modal.free.line6': 'Historia wiadomości do 30 dni.',
  'plans.modal.free.line7': 'Tylko 1 urządzenie na użytkownika.',
  'plans.modal.premium.line1': '300 000 znaków miesięcznie na konto.',
  'plans.modal.premium.line2': 'Do 100 kontaktów na użytkownika.',
  'plans.modal.premium.line3': 'Nieograniczone rozmowy i czaty (tenant).',
  'plans.modal.premium.line4': 'Do 50 MB pamięci (tenant).',
  'plans.modal.premium.line5': 'Do 3 urządzeń na użytkownika.',
  'plans.modal.premium.line6': 'Nieograniczone zaproszenia (tenant).',
  'plans.modal.premium.line7': 'Obejmuje eksport, tłumaczenie automatyczne i pliki w ramach limitów planu.',
  'plans.modal.premium_block_heading': 'Limity użycia silnika (premium)',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Program Founder',
  'plans.modal.foundation.categories_title': 'Kategorie Founder ({slots} miejsc)',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': 'Pozycja 1–25',
  'plans.modal.foundation.cat_legendary_desc': 'Pierwsi wspierający projekt. Najwyższy historyczny priorytet.',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': 'Pozycja 26–75',
  'plans.modal.foundation.cat_early_desc': 'Wczesne wsparcie ze specjalnym uznaniem.',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': 'Pozycja 76–150',
  'plans.modal.foundation.cat_std_desc': 'Miejsce Founder w ramach 150 pozycji.',
  'plans.modal.foundation.advantages_title': 'Korzyści Founder',
  'plans.modal.foundation.adv1': 'Dostęp do ograniczonej puli Founder ({slots} numerowanych miejsc).',
  'plans.modal.foundation.adv2': 'Uznanie jako użytkownik-założyciel ArChat.',
  'plans.modal.foundation.adv3': 'Odznaka i obecność Founder w doświadczeniu produktu.',
  'plans.modal.foundation.adv4': 'Historyczny priorytet i status według pozycji (1–150).',
  'plans.modal.foundation.adv5': 'Trwała korzyść powiązana z dostępem Founder, dopóki obowiązuje aktualna polityka.',
  'plans.modal.pro.tagline': 'Standardowy premium — bez komponentu Founder',
  'plans.payments_disabled.title': 'Subskrypcje',
  'plans.payments_disabled.message': 'Subskrypcje są stopniowo włączane. Możesz zobaczyć dostępne plany i ich korzyści.',
  'plans.payments_disabled.confirm': 'OK',
};